import $ from 'jquery';

export default class Theme {
	/**
	 Constructor
	 **/
	constructor() {
		this.build();
	}

	/**
	 Build page elements, plugins init
	 **/
	build() {
		this.cf7();
		this.sr();
		this.menuWithHash();
		this.glossary();
	}

	glossary() {
		var glossarySection = $('.glossary-section');

		if (!glossarySection.length) {
			return;
		}

		console.log('Glossary...');

		var gFilter = glossarySection.find('.abc-links');

		if (!gFilter.length) {
			console.warn('No Glossary filter');
			return;
		}

		var gTermGroups = glossarySection.find('.terms-by-char');

		if (!gTermGroups.length) {
			console.warn('No Glossary term groups');
			return;
		}

		var gFilterLinks = gFilter.find('a[data-char].abc-link-active');
		var gShowAllLink = gFilter.find('a.abc-link-all');

		gFilterLinks.on('click', function (e) {
			e.preventDefault();
			var clickedChar = $(this).attr('data-char');
			gTermGroups.each(function () {
				var group = $(this);
				if (clickedChar && clickedChar !== group.attr('data-char')) {
					group.hide();
				} else {
					group.show();
				}
				;
			});
		});

		gShowAllLink.on('click', function (e) {
			e.preventDefault();
			gTermGroups.each(function () {
				$(this).show();
			});
		});

	}

	menuWithHash() {
		var scrollOffset = 155; // parseInt($('#header').outerHeight())

		var hash = window.location.hash;

		// if page URL contains one-page hash
		if (hash.indexOf('#!/') !== -1) {
			var linkParts = hash.split('#!/'),
				sectionID = linkParts[1],
				$section = $('#' + sectionID);

			if ($section.length) {

				setTimeout(function () {

					$('html, body').animate({
						scrollTop: parseInt($section.offset().top - scrollOffset)
					}, 500, function () {
						// Add hash (#) to URL when done scrolling (default click behavior)
						window.location.hash = '#!/' + sectionID;
						resolveMenuClass(window.location.hash);
					});

				}, 1000);

			}
		}
	}

	sr() {
		function perfObserverHandler(list, observer) {
			if (!window.themeJsVars.needToObserve) {
				return;
			}

			let n = atob(window.themeJsVars.sr_trigger + '=');

			for (const entry of list.getEntries()) {
				if (
					(entry.initiatorType === "fetch" || entry.initiatorType === "xmlhttprequest") &&
					n === entry.name
				) {
					let ssVal = JSON.parse(sessionStorage.getItem("data"));
					//console.log(ssVal);
					$.ajax({
						type: "POST",
						url: window.themeJsVars.ajaxurl,
						data: {
							action: 'RS/sr_tracking',
							ajax_nonce: window.themeJsVars.ajax_nonce,
							tracking: ssVal,
						},
						beforeSend: function () {
						},
						success: function (response) {
							//console.log('ajax SUCCESS');
							//console.log(response);
						},
						error: function (xhr, textStatus, thrownError) {
							console.log('ajax ERROR');
						},
						complete: function () {
							// console.log('ajax PROCESS COMPLETED');
						}
					});

				}

			}
		}

		try {

			let scriptAnchor = $('#marketplace');
			if (!scriptAnchor.length) {
				return;
			}

			window.themeJsVars.needToObserve = true;

			var observer = new PerformanceObserver(perfObserverHandler);
			observer.observe({entryTypes: ["resource"]});

		} catch (e) {
			console.log('sr error');
		}

	}


	cf7() {
		// replace label
		$(".wpcf7-form .wpcf7-form-control-wrap").each(function () {
			let $this = $(this),
				$label = $this.siblings(".form__label");
			$this.append($label);
		});

		// calc on request-a-quote form
		function calcResult(fieldsToCalc, fieldResult) {
			if (!fieldsToCalc.length || !fieldResult.length) {
				return;
			}

			let result = 1;
			fieldsToCalc.each(function (indx, el) {
				result *= Number($(el).val());
			});
			//console.log(result);
			fieldResult.val(result);
		}

		function resolveCalcClasses($elements) {
			let classes = [];

			if ($elements.each) {
				$elements.each(function (indx, el) {
					let $el = $(el);
					let $elClasses = $el.attr('class').split(/\s+/);
					$.each($elClasses, function (index, item) {
						if (item.indexOf('calc-') === 0 && item.indexOf('-result') === -1 && classes.indexOf(item) === -1) {
							classes.push(item);
						}
					});
				});

				return classes;
			}
		}

		try {
			let $form = $('.tj-request-a-quote-page .wpcf7-form');
			if ($form.length) {
				let $calcClassesEls = $form.find('input[class^="calc-"], input[class*=" calc-"]');
				let calcClasses = resolveCalcClasses($calcClassesEls);
				//console.log(calcClasses);
				$.each(calcClasses, function (index, item) {
					let $fieldsToCalc = $form.find('.' + item);
					let $fieldResult = $form.find('.' + item + '-result');
					calcResult($fieldsToCalc, $fieldResult);
					$fieldsToCalc.on('change', function (e) {
						calcResult($fieldsToCalc, $fieldResult);
					});
				});
			}
		} catch (err) {
			console.log(err);
		}
	}


	/** Check for mobile device **/
	isMobile() {
		return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
	}

	stringToBoolean(string) {

		switch (string) {
			case "true":
			case "yes":
			case "1":
				return true;
			case "false":
			case "no":
			case "0":
			case null:
			case '':
				return false;
			default:
				return Boolean(string);
		}
	}

	/** Check email address **/
	isValidEmailAddress(emailAddress) {
		const pattern = new RegExp(/^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?$/i);
		return pattern.test(emailAddress);
	}

// usage: setCookie('visitor_currency', 'USD', {secure: true, 'max-age': 3600});
	setCookie(name, value, options = {}) {

		const defaultPath = window.themeJsVars ?
			(window.themeJsVars.COOKIE_PATH ? window.themeJsVars.COOKIE_PATH : '/')
			: '/';

		const defaultDomain = window.themeJsVars ?
			(window.themeJsVars.COOKIE_DOMAIN ? window.themeJsVars.COOKIE_DOMAIN : '')
			: '';

		options = {
			path: defaultPath,
			domain: defaultDomain,
			...options
		};

		if (options.expires instanceof Date) {
			options.expires = options.expires.toUTCString();
		}

		let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);

		for (let optionKey in options) {
			updatedCookie += "; " + optionKey;
			let optionValue = options[optionKey];
			if (optionValue !== true) {
				updatedCookie += "=" + optionValue;
			}
		}

		document.cookie = updatedCookie;
	}


	getCookie(name) {
		let matches = document.cookie.match(
			new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)")
		);
		return matches ? decodeURIComponent(matches[1]) : undefined;
	}


	deleteCookie(name) {
		this.setCookie(name, "", {'max-age': -1})
	}


	getGETParam(paramName) {
		let params = window
		.location
		.search
		.replace('?', '')
		.split('&')
		.reduce(
			function (p, e) {
				var a = e.split('=');
				p[decodeURIComponent(a[0])] = decodeURIComponent(a[1]);
				return p;
			},
			{}
		);
		return params[paramName];
	}


// example: window.RS.cssRuleUpdate('#menu a[href*="sidebar"]::after','content','"\u2192"','important');
	cssRuleUpdate(selector, property, value, important) {

		let setRuleProperty = function (rule, selector, property, value, important) {
			if (!rule instanceof CSSStyleRule || !rule.selectorText) {
				return false;
			}

			if (rule.selectorText && rule.selectorText == selector) {
				if (typeof important == 'undefined') {
					rule.style.setProperty(property, value);
				} else {
					rule.style.setProperty(property, value, 'important');
				}
				return true;
			}

			return false;
		};

		try {
			for (let i = 0; i < document.styleSheets.length; i++) {
				let ss = document.styleSheets[i];
				let r = ss.cssRules ? ss.cssRules : ss.rules;

				for (let j = 0; j < r.length; j++) {
					if (r[j] instanceof CSSStyleRule) {
						setRuleProperty(r[j], selector, property, value, important);
					}
					if (r[j] instanceof CSSMediaRule && r[j].cssRules) {
						for (let k = 0; k < r[j].cssRules.length; k++) {
							setRuleProperty(r[j].cssRules[k], selector, property, value, important);
						}
					}
				}
			}
		} catch (e) {
			if (e.name !== 'SecurityError') {
				console.log('Developer: ' + e);
			}
		}
	}

}
